import { render, staticRenderFns } from "./ResetInventoryButton.vue?vue&type=template&id=4f3a3705&"
import script from "./ResetInventoryButton.vue?vue&type=script&lang=js&"
export * from "./ResetInventoryButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports